import { render, staticRenderFns } from "./AddressInformation.vue?vue&type=template&id=5c27b4dd"
import script from "./AddressInformation.vue?vue&type=script&lang=js"
export * from "./AddressInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports